import { WellSchema } from './Well.styles';

export const wellStyles: WellSchema = {
  wrapper: {
    bg: 'alpha.700',
    p: '1.5',
  },
};
